function initHsTextMarquee() {
  document.querySelectorAll('[data-hs-text-marquee]').forEach((marquee) => {
    if (marquee.dataset.initialized === 'true') return;
    marquee.dataset.initialized = 'true';

    const track = marquee.querySelector('.hs-text-marquee__track');
    const originalGroup = marquee.querySelector('.hs-text-marquee__group');

    if (!track || !originalGroup) return;

    let position = 0;
    let groupWidth = 0;
    let animationFrame;
    let speed = window.innerWidth <= 749 ? 0.45 : 0.6;
    let lastWidth = window.innerWidth;

    function setup() {
      track.querySelectorAll('[data-marquee-clone]').forEach((clone) => clone.remove());

      groupWidth = originalGroup.offsetWidth;

      if (!groupWidth) return;

      while (track.scrollWidth < marquee.offsetWidth + groupWidth * 2) {
        const clone = originalGroup.cloneNode(true);
        clone.setAttribute('data-marquee-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
    }

    function animate() {
      position -= speed;

      if (Math.abs(position) >= groupWidth) {
        position = 0;
      }

      track.style.transform = `translate3d(${position}px, 0, 0)`;
      animationFrame = requestAnimationFrame(animate);
    }

    function restart() {
      cancelAnimationFrame(animationFrame);

      const currentPosition = position;

      speed = window.innerWidth <= 749 ? 0.45 : 0.6;

      setup();

      position = currentPosition;

      animate();
    }

    setup();
    animate();

    window.addEventListener('resize', () => {
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;
        restart();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initHsTextMarquee);
document.addEventListener('shopify:section:load', initHsTextMarquee);